/*
  t3p-size-memory.js (3P filter quality-of-life build, 28 Sep 2026)
  Sitewide, small. Three jobs:
  1. Remember the size a shopper picked on a collection (sessionStorage t3p_size, written
     by t3p-filters.js) and carry it onto door-collection links in the header and menus
     as ?size=h2040-w820, so switching Entrance to Internal keeps the size.
  2. Header search: when the query looks like a door size ("2040 x 820", "820",
     "2040x820x35"), add "Entrance doors / Internal doors in that size" links to the top
     of the predictive results.
  3. Product pages: keep the "More entrance doors in 2040 x 820" back-link in step with
     the selected variant.
  Rollback: remove the script tag from layout/theme.liquid.
*/
(function () {
  'use strict';
  var KEY = 't3p_size';
  var HARDWARE = ['hardware', 'handle', 'lock', 'hinge', 'furniture', 'bolt', 'stop', 'control', 'frame', 'systems', 'sale', 'accessor', 'cabinet', 'sliding', 'privacy', 'escutcheon', 'jura', 'futura', 'astron', 'garrison', 'elements', 'closer', 'viewer', 'bay-breeze', 'vendors', 'clearance', 'flash'];
  var WIDTHS = [200, 310, 360, 400, 405, 410, 420, 460, 500, 520, 620, 720, 770, 820, 870, 920, 1000, 1020, 1100, 1200];

  function memory() {
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!s) return null;
      var parts = [];
      ['h', 'w', 't'].forEach(function (k) { if (s[k] && s[k].length) parts.push(k + s[k].join(',')); });
      return parts.length ? parts.join('-') : null;
    } catch (e) { return null; }
  }

  function isDoorCollection(path) {
    if (path.indexOf('/collections/') !== 0) return false;
    var handle = path.split('/')[2] || '';
    if (!handle) return false;
    return !HARDWARE.some(function (w) { return handle.indexOf(w) > -1; });
  }

  // 1. Carry the remembered size onto door-collection links.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (!a.closest('store-header, header, .main-menu, .mega-nav, [data-t3p-carry-size]')) return;
    var mem = memory();
    if (!mem) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.origin); } catch (err) { return; }
    if (url.origin !== location.origin || !isDoorCollection(url.pathname)) return;
    if (url.search) return;
    var original = a.getAttribute('href');
    url.searchParams.set('size', mem);
    a.setAttribute('href', url.pathname + url.search);
    // Restore after the browser has read the href for this click, so the link never keeps a
    // stale size (e.g. when the click only opened the mega menu).
    setTimeout(function () { a.setAttribute('href', original); }, 0);
  }, true);

  // 2. Size-shaped search queries.
  function parseQuery(q) {
    var s = String(q).toLowerCase().replace(/mm/g, '').replace(/\s+/g, '');
    var m = s.match(/^(\d{4})x(\d{3,4})(?:x(\d{2,3}))?$/);
    if (m) return { h: +m[1], w: +m[2], t: m[3] ? +m[3] : 0 };
    var w = s.match(/^(\d{3,4})(?:wide)?$/);
    if (w && WIDTHS.indexOf(+w[1]) > -1) return { h: 0, w: +w[1], t: 0 };
    return null;
  }
  function sizeParam(d) {
    var parts = [];
    if (d.h) parts.push('h' + d.h);
    if (d.w) parts.push('w' + d.w);
    if (d.t) parts.push('t' + d.t);
    return parts.join('-');
  }
  function injectSizeSuggest(component) {
    var input = component.querySelector('.js-search-input');
    var results = component.querySelector('.js-search-results');
    if (!input || !results) return;
    var old = results.querySelector('.t3p-size-suggest');
    if (old) old.remove();
    var d = parseQuery(input.value);
    if (!d) return;
    var label = (d.h ? d.h + ' x ' : '') + d.w + (d.t ? ' x ' + d.t : '') + ' mm' + (!d.h ? ' wide' : '');
    var p = sizeParam(d);
    var box = document.createElement('div');
    box.className = 't3p-size-suggest';
    box.innerHTML = '<p class="t3p-size-suggest__title">Looking for a door size?</p>'
      + '<a class="t3p-size-suggest__link" href="/collections/entrance-doors?size=' + p + '">Entrance doors, ' + label + '</a>'
      + '<a class="t3p-size-suggest__link" href="/collections/internal-doors?size=' + p + '">Internal doors, ' + label + '</a>';
    var host = results.querySelector('.predictive-search__results') || results.querySelector('.predictive-search') || results;
    host.insertBefore(box, host.firstChild);
    if (!component.hasAttribute('open') && typeof component.open === 'function') component.open();
  }
  function patchPredictiveSearch() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('predictive-search').then(function () {
      var P = customElements.get('predictive-search');
      if (!P || P.prototype.t3pPatched) return;
      P.prototype.t3pPatched = true;
      var orig = P.prototype.renderResults;
      P.prototype.renderResults = function (markup) {
        orig.call(this, markup);
        injectSizeSuggest(this);
      };
    });
  }

  // 3. PDP back-link follows the selected variant.
  document.addEventListener('on:variant:change', function (e) {
    var link = document.querySelector('[data-t3p-backlink]');
    if (!link || !e.detail || !e.detail.variant || !e.detail.product) return;
    var names = (e.detail.product.options || []).map(function (o) { return (o.name || o).toLowerCase(); });
    var idx = names.findIndex(function (n) { return n.indexOf('size') > -1; });
    if (idx < 0) return;
    var val = (e.detail.variant.options || [])[idx];
    if (!val) return;
    var s = String(val).toLowerCase().replace(/mm/g, '').replace(/\s+/g, '');
    var m = s.match(/^(\d{4})x(\d{3,4})/);
    if (!m) return;
    var a = link.querySelector('a');
    var span = link.querySelector('[data-t3p-backlink-size]');
    if (a) a.setAttribute('href', '/collections/' + link.dataset.collection + '?size=h' + m[1] + '-w' + m[2]);
    if (span) span.textContent = m[1] + ' x ' + m[2];
  });

  patchPredictiveSearch();
})();
